import React, { useState, useEffect } from "react"
import { Wrapper } from "../Panel";
import BorderPopper from "./BorderPopper";

const Border = (props: any) => {
    const { value, open, key, label, placeholder, type } = props;
    return (
        <Wrapper key={key}>
            <p className="panel-label">
                {label}
            </p>
            <p
                className="font-medium rounded-md cursor-pointer "
                data-test-id={`${type}-${label}`}
                style={{
                    color: "#0466C8",
                    backgroundColor: "rgba(4, 102, 200, 0.1)",
                    height: "28px",
                    width: "170px",
                    padding: "5px"
                }}
                onClick={((e:any) => {e.stopPropagation(); open()})}
            >
                <div className="flex items-center justify-center">
                    <p>{placeholder}</p>
                </div>
            </p>
        </Wrapper>
    )
}
export default Border;